import { momentFromDate } from 'src/services/date-utils';

export default function DateFormat({ date, format = 'DD/MM/YYYY' }: { date: string; format?: string }) {
    if (!date) {
        return null;
    }

    return <>{momentFromDate(date).format(format)}</>;
}
